import { get, post, put, download } from 'services/api-client';

const reportService = {
  getById: (id) => get(`/report/${id}`),

  getReportStats: () => get(`/report/report-stats`),

  assign: (id) => put(`/report/${id}/assign`),

  notify: (id) => put(`/report/${id}/notify`),

  create: (data) => post(`/report/create`, data),

  updateReport: (report) => post(`report/update`, report),

  saveLabcorpNumber: (id, labcorpNumber) => put(`/report/${id}/update/labcorp-number?labcorpNumber=${labcorpNumber}`),

  cancel: (id, sendEmailOnCancel) => put(`/report/${id}/cancel/${sendEmailOnCancel}`),

  downloadReport: (report) => download(`/report/${report.id}/download/report`, `Precision Health Reports ${report.type}-${report.patientName}-${report.creationDate}.pdf`),

  toggleReportVisibility: (id) => put(`/report/${id}/toggle-visibility`),

  exportDataFeed: (report) => download(`report/${report.id}/download/datafeed`, `${report.id}_${report.patientName.split(' ').join('_')}_${report.completionDate}.json`),

  downloadReqDocument: (report) => download(`report/${report.id}/download/req-document`, `Requisition_${report.type}-${report.patientName}-${report.creationDate}.pdf`),

  getReportTagForm: (id) => get(`/report/${id}/tag/form`),

  updateReportTag: (data) => put(`/report/tag/update`, data),

  isReportInProgress: (clientId, patientId) => get(`report/client/${clientId}/patient/${patientId}/progress`),

  getPatientEmail: (id) => get(`/report/${id}/patient/email`),

  updatePatientEmail: (id, email) => put(`/report/${id}/patient/email?email=${encodeURIComponent(email)}`),
}

export default reportService;